/**
 * Objective Details Page - Constants and Utilities
 */

import { Timestamp } from 'firebase/firestore';
import type { Objective, KeyResult } from '../../models';
import { MOCK_OBJECTIVES } from '../Objectives/objectives.definitions';

/**
 * Get a mock objective by ID (for development)
 */
export function getMockObjectiveById(id: string): Objective | undefined {
  return MOCK_OBJECTIVES.find((obj: Objective) => obj.id === id);
}

/**
 * Mock key results for the selected objective
 */
export function getMockKeyResultsByObjectiveId(objectiveId: string): KeyResult[] {
  return [
    {
      id: 'kr-1',
      objectiveId: objectiveId,
      objectiveTitle: 'Aumentar receita em 30%',
      cycleId: 'cycle-1',
      title: 'Aumentar receita recorrente para R$ 500k/mês',
      description: 'Crescimento sustentável da receita mensal',
      metricType: 'currency',
      unit: 'k',
      initialValue: 300,
      currentValue: 420,
      targetValue: 500,
      progress: 60,
      status: 'on_track',
      responsibleId: 'user-1',
      responsibleName: 'João Silva',
      responsibleEmail: 'joao@example.com',
      lastCheckInDate: Timestamp.fromDate(new Date('2025-01-26')),
      checkInCount: 3,
      startDate: Timestamp.fromDate(new Date('2025-01-01')),
      targetDate: Timestamp.fromDate(new Date('2025-03-31')),
      completedAt: null,
      createdAt: Timestamp.fromDate(new Date('2025-01-15')),
      updatedAt: Timestamp.fromDate(new Date('2025-01-26')),
      _metadata: { version: 1, lastModifiedBy: 'user-1' },
    },
    {
      id: 'kr-2',
      objectiveId: objectiveId,
      objectiveTitle: 'Aumentar receita em 30%',
      cycleId: 'cycle-1',
      title: 'Fechar 10 novos contratos enterprise',
      description: 'Foco em clientes de grande porte',
      metricType: 'number',
      unit: 'contratos',
      initialValue: 0,
      currentValue: 6,
      targetValue: 10,
      progress: 60,
      status: 'on_track',
      responsibleId: 'user-2',
      responsibleName: 'Maria Santos',
      responsibleEmail: 'maria@example.com',
      lastCheckInDate: Timestamp.fromDate(new Date('2025-01-25')),
      checkInCount: 2,
      startDate: Timestamp.fromDate(new Date('2025-01-01')),
      targetDate: Timestamp.fromDate(new Date('2025-03-31')),
      completedAt: null,
      createdAt: Timestamp.fromDate(new Date('2025-01-15')),
      updatedAt: Timestamp.fromDate(new Date('2025-01-25')),
      _metadata: { version: 1, lastModifiedBy: 'user-2' },
    },
    {
      id: 'kr-3',
      objectiveId: objectiveId,
      objectiveTitle: 'Aumentar receita em 30%',
      cycleId: 'cycle-1',
      title: 'Aumentar taxa de conversão para 25%',
      description: 'Otimizar funil de vendas',
      metricType: 'percentage',
      unit: '%',
      initialValue: 18,
      currentValue: 22,
      targetValue: 25,
      progress: 57,
      status: 'at_risk',
      responsibleId: 'user-3',
      responsibleName: 'Pedro Costa',
      responsibleEmail: 'pedro@example.com',
      lastCheckInDate: Timestamp.fromDate(new Date('2025-01-24')),
      checkInCount: 3,
      startDate: Timestamp.fromDate(new Date('2025-01-01')),
      targetDate: Timestamp.fromDate(new Date('2025-03-31')),
      completedAt: null,
      createdAt: Timestamp.fromDate(new Date('2025-01-15')),
      updatedAt: Timestamp.fromDate(new Date('2025-01-24')),
      _metadata: { version: 1, lastModifiedBy: 'user-3' },
    },
  ];
}

/**
 * Tab configuration
 */
export const DETAILS_TABS = [
  { id: 'keyResults' as const, label: 'Key Results', icon: '🎯' },
  { id: 'checkIns' as const, label: 'Check-ins', icon: '✅' },
];
